class ProductSpecification {
  constructor() {
    this.elements = this.getElements();
    if (!this.elements.viewMoreBtn || !this.elements.rows.length) return;
    
    this.visibleRows = this.getVisibleRows();
    this.bindEvents();
    this.setupInitialState();
  }

  getElements() {
    const sectionElement = document.querySelector('.product-specification[data-section-id]');
    const table = sectionElement?.querySelector('[data-specification-table]');
    
    return {
      sectionElement,
      table,
      rows: table?.querySelectorAll('.product-specification__row') || [],
      viewMoreBtn: sectionElement?.querySelector('[data-view-more-btn]')
    };
  }

  getVisibleRows() {
    const visibleRowsSetting = this.elements.sectionElement?.getAttribute('data-visible-rows');
    return parseInt(visibleRowsSetting) || 12;
  }

  bindEvents() {
    this.elements.viewMoreBtn.addEventListener('click', this.toggleSpecification.bind(this));
  }

  setupInitialState() {
    const { rows, viewMoreBtn } = this.elements;
    const totalRows = rows.length;
    
    if (totalRows > this.visibleRows) {
      this.hideRows(this.visibleRows, totalRows);
      this.updateButtonText('more');
      viewMoreBtn.setAttribute('data-expanded', 'false');
    } else {
      viewMoreBtn.style.display = 'none';
    }
  }

  toggleSpecification() {
    const { rows, viewMoreBtn } = this.elements;
    const isExpanded = viewMoreBtn.getAttribute('data-expanded') === 'true';
    
    if (isExpanded) {
      this.hideRows(this.visibleRows, rows.length);
      this.updateButtonText('more');
      viewMoreBtn.setAttribute('data-expanded', 'false');
    } else {
      this.showRows(this.visibleRows, rows.length);
      this.updateButtonText('less');
      viewMoreBtn.setAttribute('data-expanded', 'true');
    }
  }

  hideRows(startIndex, endIndex) {
    for (let i = startIndex; i < endIndex; i++) {
      this.elements.rows[i].classList.remove('product-specification__row--expanded');
      this.elements.rows[i].classList.add('product-specification__row--collapsed');
    }
  }

  showRows(startIndex, endIndex) {
    for (let i = startIndex; i < endIndex; i++) {
      this.elements.rows[i].classList.remove('product-specification__row--collapsed');
      this.elements.rows[i].classList.add('product-specification__row--expanded');
    }
  }

  updateButtonText(type) {
    const attribute = type === 'more' ? 'data-view-more-text' : 'data-view-less-text';
    this.elements.viewMoreBtn.textContent = this.elements.viewMoreBtn.getAttribute(attribute);
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ProductSpecification();
});

// Re-initialize on section load (for Shopify's section rendering)
document.addEventListener('shopify:section:load', () => {
  new ProductSpecification();
});
